module.exports = {
	"mobile-portrait": "Mobile (Portrait)",
	"mobile-landscape": "Mobile (Landscape)",
	"tablet-portrait": "Tablet (Portrait)",
	"tablet-landscape": "Tablet (Landscape)",
	"desktop": "Desktop"
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/App/Preview/config/devices.json
// module id = ./app/javascript/packs/App/Preview/config/devices.json
// module chunks = 1